/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetInvoiceIssuerDto
 */
export interface GetInvoiceIssuerDto {
    /**
     * 
     * @type {string}
     * @memberof GetInvoiceIssuerDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetInvoiceIssuerDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetInvoiceIssuerDto
     */
    address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetInvoiceIssuerDto
     */
    nip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetInvoiceIssuerDto
     */
    bankName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetInvoiceIssuerDto
     */
    bankAccount?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetInvoiceIssuerDto
     */
    note?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetInvoiceIssuerDto
     */
    footer?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetInvoiceIssuerDto
     */
    symbol?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetInvoiceIssuerDto
     */
    symbolCorrection?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetInvoiceIssuerDto
     */
    krd: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetInvoiceIssuerDto
     */
    active: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetInvoiceIssuerDto
     */
    isDefault: boolean;
}

/**
 * Check if a given object implements the GetInvoiceIssuerDto interface.
 */
export function instanceOfGetInvoiceIssuerDto(value: object): value is GetInvoiceIssuerDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('krd' in value) || value['krd'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('isDefault' in value) || value['isDefault'] === undefined) return false;
    return true;
}

export function GetInvoiceIssuerDtoFromJSON(json: any): GetInvoiceIssuerDto {
    return GetInvoiceIssuerDtoFromJSONTyped(json, false);
}

export function GetInvoiceIssuerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetInvoiceIssuerDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'address': json['address'] == null ? undefined : json['address'],
        'nip': json['nip'] == null ? undefined : json['nip'],
        'bankName': json['bankName'] == null ? undefined : json['bankName'],
        'bankAccount': json['bankAccount'] == null ? undefined : json['bankAccount'],
        'note': json['note'] == null ? undefined : json['note'],
        'footer': json['footer'] == null ? undefined : json['footer'],
        'symbol': json['symbol'] == null ? undefined : json['symbol'],
        'symbolCorrection': json['symbolCorrection'] == null ? undefined : json['symbolCorrection'],
        'krd': json['krd'],
        'active': json['active'],
        'isDefault': json['isDefault'],
    };
}

export function GetInvoiceIssuerDtoToJSON(value?: GetInvoiceIssuerDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'address': value['address'],
        'nip': value['nip'],
        'bankName': value['bankName'],
        'bankAccount': value['bankAccount'],
        'note': value['note'],
        'footer': value['footer'],
        'symbol': value['symbol'],
        'symbolCorrection': value['symbolCorrection'],
        'krd': value['krd'],
        'active': value['active'],
        'isDefault': value['isDefault'],
    };
}

